/*
 * Bundle Builder — Southern Scholar
 * Interactive bundle page: select products, track discount tiers, add to cart
 *
 * Discount tiers are VISUAL only — the actual discount must be configured
 * in Shopify Admin → Discounts → Automatic discount (Buy X Get Y or Amount Off)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ss_bundle_items';

  /* =============================================
     Constructor
     ============================================= */
  function BundleBuilder(el) {
    this.root = el;
    this.maxItems = parseInt(el.dataset.maxItems) || 10;
    this.tiers = JSON.parse(el.dataset.tiers || '[]');
    this.moneyFmt = el.dataset.moneyFormat || '${{amount}}';
    this.items = []; // { productId, variantId, title, variantTitle, price, image, handle }
    this.mobileOpen = false;

    /* Best-seller rank map.
       Parses the JSON array of product IDs rendered by Liquid (in
       best-selling collection order) into an O(1) lookup: productId -> rank.
       Empty when the merchant hasn't configured a bestseller_reference. */
    this.bestsellerRank = {};
    try {
      var ids = JSON.parse(el.dataset.bestsellerOrder || '[]');
      for (var bi = 0; bi < ids.length; bi++) {
        this.bestsellerRank[ids[bi]] = bi;
      }
    } catch (e) { /* ignore malformed JSON */ }

    /* On-demand order maps fetched from Shopify (productId -> rank), keyed by
       Shopify sort_by value (e.g. 'best-selling', 'manual'). Populated lazily by
       fetchOrder() the first time the user picks that sort, then cached. This
       lets "Best-selling" and "Featured" use real Shopify orderings without the
       merchant maintaining a duplicate reference collection. */
    this.fetchedRanks = {};
    this.collectionHandle = el.dataset.collectionHandle || '';

    this.cache();
    this.bind();
    this.restore();
    this.render();
  }

  /* =============================================
     DOM cache
     ============================================= */
  BundleBuilder.prototype.cache = function () {
    var r = this.root;
    this.grid         = r.querySelector('[data-bundle-grid]');
    this.cards        = r.querySelectorAll('[data-bundle-card]');
    this.search       = r.querySelector('[data-bundle-search]');
    this.filterSize    = r.querySelector('[data-filter-size]');
    this.filterColor   = r.querySelector('[data-filter-color]');
    this.filterPattern = r.querySelector('[data-filter-pattern]');
    this.sortEl        = r.querySelector('[data-bundle-sort]');
    /* Stamp each card with its initial DOM index so the "Featured" sort
       can restore the original collection order after a different sort.
       Doing this once at cache time means subsequent sorts are O(n log n)
       with no DOM walks for ordering. */
    for (var ci = 0; ci < this.cards.length; ci++) {
      this.cards[ci]._originalIndex = ci;
    }
    this.countEl      = r.querySelector('[data-bundle-count]');
    this.progressEls  = r.querySelectorAll('[data-tier-progress]');
    this.slotsWrap    = r.querySelector('[data-bundle-items]');
    this.subtotalEl   = r.querySelector('[data-bundle-subtotal]');
    this.savingsEl    = r.querySelector('[data-bundle-savings]');
    this.savingsRow   = r.querySelector('[data-bundle-savings-row]');
    this.totalEl      = r.querySelector('[data-bundle-total]');
    this.ctaBtn       = r.querySelector('[data-bundle-add-to-cart]');
    this.hintEl       = r.querySelector('[data-bundle-hint]');
    this.tierMarkers  = r.querySelectorAll('[data-tier-marker]');
    this.mobileBar    = r.querySelector('[data-bundle-mobile-bar]');
    this.mobCount     = r.querySelector('[data-mobile-count]');
    this.mobSavings   = r.querySelector('[data-mobile-savings]');
    this.mobViewBtn   = r.querySelector('[data-mobile-view-bundle]');
    this.scrollBtn    = r.querySelector('[data-scroll-top]');
    this.sidebar      = r.querySelector('[data-bundle-sidebar]');
    this.closeBtn     = r.querySelector('[data-close-drawer]');
  };

  /* =============================================
     Event binding (event delegation)
     ============================================= */
  BundleBuilder.prototype.bind = function () {
    var self = this;

    /* ---------- clicks inside the builder ---------- */
    this.root.addEventListener('click', function (e) {
      // Add-to-bundle
      var addBtn = e.target.closest('[data-add-to-bundle]');
      if (addBtn) {
        self.handleAdd(addBtn.closest('[data-bundle-card]'));
        return;
      }
      // Remove from slot
      var rm = e.target.closest('[data-slot-remove]');
      if (rm) {
        self.removeItem(parseInt(rm.dataset.slotRemove));
        return;
      }
      // Image carousel arrows
      var prevBtn = e.target.closest('[data-slide-prev]');
      var nextBtn = e.target.closest('[data-slide-next]');
      if (prevBtn || nextBtn) {
        e.preventDefault();
        e.stopPropagation();
        var imgWrap = (prevBtn || nextBtn).closest('.bundle-card__image');
        var slides = imgWrap.querySelectorAll('.bundle-card__img');
        var total = slides.length;
        if (total < 2) return;
        var current = 0;
        for (var i = 0; i < total; i++) {
          if (slides[i].classList.contains('is-active')) { current = i; break; }
        }
        slides[current].classList.remove('is-active');
        var next = prevBtn ? (current - 1 + total) % total : (current + 1) % total;
        slides[next].classList.add('is-active');
        return;
      }
    });

    /* ---------- variant select change ---------- */
    this.root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-variant-select]')) return;
      var card = e.target.closest('[data-bundle-card]');
      if (!card) return;
      var opt = e.target.options[e.target.selectedIndex];
      // swap first image (active slide)
      var newImg = opt.dataset.image;
      if (newImg) {
        var img = card.querySelector('.bundle-card__img.is-active') || card.querySelector('.bundle-card__img');
        if (img) img.src = newImg;
      }
      // swap price
      var p = parseInt(opt.dataset.price);
      var priceEl = card.querySelector('[data-card-price]');
      if (priceEl && p) priceEl.textContent = self.money(p);

      // swap compare-at price (strikethrough). The element is always
      // present in the DOM; we just toggle [hidden] and the text content.
      // Hide when there's no compare price, or when it isn't actually
      // higher than the sale price (defensive — bad data shouldn't print
      // a strikethrough that equals the price).
      var compareEl = card.querySelector('[data-card-compare]');
      if (compareEl) {
        var cp = parseInt(opt.dataset.comparePrice) || 0;
        if (cp && cp > p) {
          compareEl.textContent = self.money(cp);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      // Update card highlight based on whether THIS variant is in the bundle
      var vid = e.target.value;
      var inBundle = false;
      for (var i = 0; i < self.items.length; i++) {
        if (self.items[i].variantId === vid) { inBundle = true; break; }
      }
      card.classList.toggle('bundle-card--added', inBundle);
    });

    /* ---------- search & filters ---------- */
    var filterDelay;
    function triggerFilter() {
      clearTimeout(filterDelay);
      filterDelay = setTimeout(function () { self.applyFilters(); }, 200);
    }

    if (this.search) this.search.addEventListener('input', triggerFilter);
    if (this.filterSize) this.filterSize.addEventListener('change', triggerFilter);
    if (this.filterColor) this.filterColor.addEventListener('change', triggerFilter);
    if (this.filterPattern) this.filterPattern.addEventListener('change', triggerFilter);

    /* ---------- sort dropdown + URL sync ----------
       On change: reorder the grid and reflect the choice in the URL
       (replaceState so the back button isn't polluted with sort steps).
       On init: read `?sort=` from the URL and pre-apply if present, so
       sharing/bookmarking a sort works. */
    if (this.sortEl) {
      this.sortEl.addEventListener('change', function () {
        self.runSort(self.sortEl.value);
        self.updateURLSort(self.sortEl.value);
      });

      // Pre-apply from URL if user landed with ?sort=...
      var urlParams = new URLSearchParams(window.location.search);
      var urlSort = urlParams.get('sort');
      if (urlSort) {
        var matchingOption = this.sortEl.querySelector('option[value="' + urlSort + '"]');
        if (matchingOption) {
          this.sortEl.value = urlSort;
          self.runSort(urlSort);
        }
      }
    }

    /* ---------- mobile filter toggle ---------- */
    var filtersToggle = this.root.querySelector('[data-filters-toggle]');
    var filtersDropdowns = this.root.querySelector('[data-filters-dropdowns]');
    if (filtersToggle && filtersDropdowns) {
      filtersToggle.addEventListener('click', function () {
        filtersToggle.classList.toggle('is-open');
        filtersDropdowns.classList.toggle('is-open');
      });
    }

    /* ---------- CTA ---------- */
    if (this.ctaBtn) this.ctaBtn.addEventListener('click', function () { self.addToCart(); });

    /* ---------- mobile view ---------- */
    if (this.mobViewBtn) this.mobViewBtn.addEventListener('click', function () { self.toggleMobile(); });
    if (this.closeBtn) this.closeBtn.addEventListener('click', function () { self.toggleMobile(); });

    /* ---------- scroll-to-top ---------- */
    if (this.scrollBtn) {
      this.scrollBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      window.addEventListener('scroll', function () {
        self.scrollBtn.classList.toggle('bundle-scroll-top--visible', window.scrollY > 400);
      }, { passive: true });
    }
  };

  /* =============================================
     Add / Remove items
     ============================================= */
  BundleBuilder.prototype.handleAdd = function (card) {
    if (!card) return;
    var pid = card.dataset.productId;

    var sel = card.querySelector('[data-variant-select]');
    var variantId, variantTitle, price;

    if (sel && sel.tagName === 'SELECT') {
      var opt = sel.options[sel.selectedIndex];
      variantId = sel.value;
      variantTitle = opt.textContent.trim();
      price = parseInt(opt.dataset.price);
    } else if (sel) {
      variantId = sel.value;
      variantTitle = '';
      price = parseInt(sel.dataset.price);
    }

    // Toggle: if this exact variant is already in bundle, remove it
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].variantId === variantId) {
        this.removeItem(i);
        return;
      }
    }

    // Max check
    if (this.items.length >= this.maxItems) {
      this.shake(this.ctaBtn);
      return;
    }

    this.items.push({
      productId: pid,
      variantId: variantId,
      title: card.dataset.productTitle,
      variantTitle: variantTitle,
      price: price,
      image: card.querySelector('.bundle-card__img--primary')
        ? card.querySelector('.bundle-card__img--primary').src
        : card.dataset.productImage,
      handle: card.dataset.productHandle
    });

    card.classList.add('bundle-card--added');
    this.save();
    this.render();
  };

  BundleBuilder.prototype.removeItem = function (idx) {
    if (idx < 0 || idx >= this.items.length) return;
    var removed = this.items.splice(idx, 1)[0];

    // Only remove card highlight if no other variants of this product remain
    var stillHasProduct = false;
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].productId === removed.productId) {
        stillHasProduct = true;
        break;
      }
    }
    if (!stillHasProduct) {
      var card = this.root.querySelector('[data-product-id="' + removed.productId + '"]');
      if (card) card.classList.remove('bundle-card--added');
    }

    this.save();
    this.render();
  };

  /* =============================================
     Discount tier logic
     ============================================= */
  BundleBuilder.prototype.getDiscount = function () {
    var n = this.items.length, d = 0;
    for (var i = this.tiers.length - 1; i >= 0; i--) {
      if (n >= this.tiers[i].qty) { d = this.tiers[i].pct; break; }
    }
    return d;
  };

  BundleBuilder.prototype.getSubtotal = function () {
    var s = 0;
    for (var i = 0; i < this.items.length; i++) s += this.items[i].price;
    return s;
  };

  /* =============================================
     Render everything
     ============================================= */
  BundleBuilder.prototype.render = function () {
    var count    = this.items.length;
    var discount = this.getDiscount();
    var subtotal = this.getSubtotal();
    var savings  = Math.round(subtotal * discount / 100);
    var total    = subtotal - savings;

    // Count badge
    if (this.countEl) this.countEl.textContent = count + ' / ' + this.maxItems;

    // Progress bar(s) — sync every copy (desktop sidebar + mobile-fixed strip).
    // We query all because the section now renders the tiers in two places so
    // mobile users see the discount goal even when the drawer is closed.
    if (this.progressEls && this.progressEls.length) {
      var pct = Math.min(count / this.maxItems * 100, 100) + '%';
      for (var pi = 0; pi < this.progressEls.length; pi++) {
        this.progressEls[pi].style.width = pct;
      }
    }

    // Tier marker highlights
    for (var t = 0; t < this.tierMarkers.length; t++) {
      var m = this.tierMarkers[t];
      var ti = parseInt(m.dataset.tierMarker) - 1;
      if (ti >= 0 && ti < this.tiers.length) {
        m.classList.toggle('bundle-tiers__marker--active', count >= this.tiers[ti].qty);
      }
    }

    // Slots
    this.renderSlots();

    // Totals
    if (this.subtotalEl) this.subtotalEl.textContent = this.money(subtotal);
    if (this.savingsRow) this.savingsRow.style.display = discount > 0 ? 'flex' : 'none';
    if (this.savingsEl) this.savingsEl.textContent = '-' + this.money(savings);
    if (this.totalEl) this.totalEl.textContent = this.money(total);

    // CTA text
    if (this.ctaBtn) {
      this.ctaBtn.disabled = count === 0;
      this.ctaBtn.textContent = discount > 0
        ? 'ADD BUNDLE TO CART \u2014 ' + discount + '% OFF'
        : 'ADD BUNDLE TO CART';
    }

    // Hint message
    if (this.hintEl) {
      if (count === 0) {
        this.hintEl.textContent = 'Add ' + this.tiers[0].qty + ' items to unlock ' + this.tiers[0].pct + '% off';
        this.hintEl.className = 'bundle-sidebar__hint';
      } else if (discount > 0) {
        var next = null;
        for (var n = 0; n < this.tiers.length; n++) {
          if (count < this.tiers[n].qty) { next = this.tiers[n]; break; }
        }
        if (next) {
          this.hintEl.textContent = 'Add ' + (next.qty - count) + ' more for ' + next.pct + '% off!';
        } else {
          this.hintEl.textContent = '\uD83C\uDF89 Maximum savings unlocked!';
        }
        this.hintEl.className = 'bundle-sidebar__hint bundle-sidebar__hint--success';
      } else {
        this.hintEl.textContent = 'Add ' + (this.tiers[0].qty - count) + ' more to unlock ' + this.tiers[0].pct + '% off';
        this.hintEl.className = 'bundle-sidebar__hint';
      }
    }

    // Mobile bar
    if (this.mobCount) this.mobCount.textContent = count;
    if (this.mobSavings) {
      this.mobSavings.textContent = discount > 0 ? 'Save ' + discount + '% \u2014 ' + this.money(savings) : '';
    }

    // Update card highlights based on currently selected variant
    for (var c = 0; c < this.cards.length; c++) {
      var card = this.cards[c];
      var sel = card.querySelector('[data-variant-select]');
      var vid = sel ? sel.value : null;
      var variantInBundle = false;
      if (vid) {
        for (var v = 0; v < this.items.length; v++) {
          if (this.items[v].variantId === vid) { variantInBundle = true; break; }
        }
      }
      card.classList.toggle('bundle-card--added', variantInBundle);
      card.classList.toggle('bundle-card--disabled',
        count >= this.maxItems && !variantInBundle);
    }
  };

  /* ---------- render sidebar slots ---------- */
  BundleBuilder.prototype.renderSlots = function () {
    if (!this.slotsWrap) return;
    var h = '';

    for (var i = 0; i < this.items.length; i++) {
      var it = this.items[i];
      h += '<div class="bundle-slot bundle-slot--filled bundle-slot--animate">'
        + '<div class="bundle-slot__image"><img src="' + this.esc(it.image) + '" alt="" width="44" height="44" loading="lazy"></div>'
        + '<div class="bundle-slot__info">'
        +   '<div class="bundle-slot__name">' + this.esc(it.title) + '</div>'
        +   (it.variantTitle ? '<div class="bundle-slot__variant-name">' + this.esc(it.variantTitle) + '</div>' : '')
        + '</div>'
        + '<span class="bundle-slot__price">' + this.money(it.price) + '</span>'
        + '<button class="bundle-slot__remove" data-slot-remove="' + i + '" aria-label="Remove">&times;</button>'
        + '</div>';
    }

    for (var e = this.items.length; e < this.maxItems; e++) {
      h += '<div class="bundle-slot bundle-slot--empty">'
        + '<div class="bundle-slot__image"><span class="bundle-slot__plus">+</span></div>'
        + '<span class="bundle-slot__text">Select a product</span>'
        + '</div>';
    }

    this.slotsWrap.innerHTML = h;
  };

  /* =============================================
     Sort + URL param sync
     ---------------------------------------------
     Sort is purely client-side: we reorder the existing card nodes via
     a documentFragment (one DOM write instead of n appendChild calls).
     Filter `display: none` is preserved across sorts because we only
     move nodes, never touch their style.

     Sort keys mirror Shopify's standard collection-sort identifiers so
     URLs are consistent with the rest of the site (e.g. `?sort=
     price-ascending` works the same here as on /collections/all).
     ============================================= */
  /* Resolve the productId -> rank map to use for a given sort key, or null when
     we should fall back to the original DOM order.
       - best-selling: Liquid reference collection (if configured) else the
         order fetched from Shopify (?sort_by=best-selling).
       - featured: the manual/curated order fetched from Shopify
         (?sort_by=manual). Falls back to original DOM order when unavailable. */
  BundleBuilder.prototype.rankMapFor = function (sortKey) {
    if (sortKey === 'best-selling') {
      if (this.bestsellerRank && Object.keys(this.bestsellerRank).length) return this.bestsellerRank;
      return this.fetchedRanks['best-selling'] || null;
    }
    if (sortKey === 'featured') {
      return this.fetchedRanks['manual'] || null;
    }
    return null;
  };

  /* Fetch a product-ID ordering from Shopify for the given sort_by value, build
     a rank map, cache it, and invoke cb(map). Uses the lightweight
     `?view=bundle-order` alternate collection template. Fails soft: on any
     error cb is called so the caller can fall back to the original order. */
  BundleBuilder.prototype.fetchOrder = function (sortBy, cb) {
    var self = this;
    if (this.fetchedRanks[sortBy]) { cb(this.fetchedRanks[sortBy]); return; }
    if (!this.collectionHandle || !window.fetch) { cb(null); return; }

    var url = '/collections/' + encodeURIComponent(this.collectionHandle) +
              '?view=bundle-order&sort_by=' + encodeURIComponent(sortBy);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var ids = null;
        try { ids = JSON.parse((txt || '').trim()); } catch (e) { ids = null; }
        var map = {};
        if (ids && ids.length) {
          for (var i = 0; i < ids.length; i++) map[ids[i]] = i;
        }
        self.fetchedRanks[sortBy] = map;
        cb(map);
      })
      .catch(function () { cb(null); });
  };

  /* Dispatch a sort request: lazily fetch the ordering for best-selling/featured
     the first time it's needed, then apply. Other sorts apply immediately. */
  BundleBuilder.prototype.runSort = function (sortKey) {
    var self = this;
    if (sortKey === 'best-selling' && !this.rankMapFor('best-selling')) {
      this.fetchOrder('best-selling', function () { self.applySort(sortKey); });
    } else if (sortKey === 'featured' && !this.rankMapFor('featured')) {
      this.fetchOrder('manual', function () { self.applySort(sortKey); });
    } else {
      this.applySort(sortKey);
    }
  };

  BundleBuilder.prototype.applySort = function (sortKey) {
    if (!this.grid || !this.cards || !this.cards.length) return;

    // Build a fresh array (NodeList isn't sortable in older browsers)
    var arr = Array.prototype.slice.call(this.cards);

    var rank = this.rankMapFor(sortKey);

    arr.sort(function (a, b) {
      switch (sortKey) {
        case 'price-ascending':
          return parseInt(a.dataset.productPrice || 0) - parseInt(b.dataset.productPrice || 0);
        case 'price-descending':
          return parseInt(b.dataset.productPrice || 0) - parseInt(a.dataset.productPrice || 0);
        case 'created-descending':
          return parseInt(b.dataset.productCreated || 0) - parseInt(a.dataset.productCreated || 0);
        case 'best-selling':
        case 'featured':
          /* Use the resolved rank map (best-selling or manual/featured order).
             Cards missing from the map sink to the bottom (rank = Infinity) and
             keep their original DOM order among themselves. When no map is
             available, fall back entirely to the original DOM order. */
          if (!rank) return (a._originalIndex || 0) - (b._originalIndex || 0);
          var aRank = rank[a.dataset.productId];
          var bRank = rank[b.dataset.productId];
          aRank = (aRank === undefined) ? Infinity : aRank;
          bRank = (bRank === undefined) ? Infinity : bRank;
          if (aRank !== bRank) return aRank - bRank;
          return (a._originalIndex || 0) - (b._originalIndex || 0);
        default:
          return (a._originalIndex || 0) - (b._originalIndex || 0);
      }
    });

    // Single DOM write: detach + reattach in new order via fragment.
    var frag = document.createDocumentFragment();
    for (var i = 0; i < arr.length; i++) frag.appendChild(arr[i]);
    this.grid.appendChild(frag);
  };

  BundleBuilder.prototype.updateURLSort = function (sortKey) {
    if (!window.history || !window.history.replaceState) return;

    var url = new URL(window.location.href);
    if (sortKey && sortKey !== 'featured') {
      url.searchParams.set('sort', sortKey);
    } else {
      // Clean URL when sort is default — no point carrying ?sort=featured
      url.searchParams.delete('sort');
    }
    window.history.replaceState({}, '', url.toString());
  };

  /* =============================================
     Search / filter
     ============================================= */
  BundleBuilder.prototype.applyFilters = function () {
    var q       = this.search        ? this.search.value.toLowerCase().trim()        : '';
    var size    = this.filterSize     ? this.filterSize.value.trim()                  : '';
    var color   = this.filterColor    ? this.filterColor.value.toLowerCase().trim()   : '';
    var pattern = this.filterPattern  ? this.filterPattern.value.toLowerCase().trim() : '';
    var visible = 0;

    for (var i = 0; i < this.cards.length; i++) {
      var card  = this.cards[i];
      var show  = true;

      // Text search
      if (q) {
        var title = (card.dataset.productTitle || '').toLowerCase();
        if (title.indexOf(q) < 0) show = false;
      }

      // Size filter — check if ANY available variant has this size
      if (show && size) {
        var sizes = (card.dataset.sizes || '').split(',');
        var sizeMatch = false;
        for (var s = 0; s < sizes.length; s++) {
          if (sizes[s].trim() === size) { sizeMatch = true; break; }
        }
        if (!sizeMatch) show = false;
      }

      // Color filter — card can have multiple colors (comma-separated in data-colors)
      if (show && color) {
        var cardColors = (card.dataset.colors || '').toLowerCase().split(',');
        var colorMatch = false;
        for (var c = 0; c < cardColors.length; c++) {
          if (cardColors[c].trim() === color) { colorMatch = true; break; }
        }
        if (!colorMatch) show = false;
      }

      // Pattern filter — card can have multiple patterns (comma-separated in data-patterns)
      if (show && pattern) {
        var cardPatterns = (card.dataset.patterns || '').toLowerCase().split(',');
        var patternMatch = false;
        for (var p = 0; p < cardPatterns.length; p++) {
          if (cardPatterns[p].trim() === pattern) { patternMatch = true; break; }
        }
        if (!patternMatch) show = false;
      }

      card.style.display = show ? '' : 'none';
      if (show) visible++;

      // Auto-select the matching variant when size filter is active
      if (show && size) {
        var sel = card.querySelector('[data-variant-select]');
        if (sel && sel.tagName === 'SELECT') {
          for (var o = 0; o < sel.options.length; o++) {
            if (sel.options[o].text.trim() === size) {
              sel.selectedIndex = o;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      }
    }

    // "No results" message
    var nr = this.grid.querySelector('.bundle-no-results');
    if (visible === 0 && !nr) {
      var d = document.createElement('div');
      d.className = 'bundle-no-results';
      d.textContent = 'No products found. Try adjusting your filters.';
      this.grid.appendChild(d);
    } else if (visible > 0 && nr) {
      nr.remove();
    }
  };

  /* =============================================
     Add bundle to Shopify cart
     ============================================= */
  BundleBuilder.prototype.addToCart = function () {
    if (this.items.length === 0) return;
    var self = this;
    var discount = this.getDiscount();
    var bundleId = 'bundle-' + Date.now();

    // Build items array
    var cartItems = [];
    for (var i = 0; i < this.items.length; i++) {
      cartItems.push({
        id: parseInt(this.items[i].variantId),
        quantity: 1,
        properties: {
          '_bundle_id': bundleId,
          '_bundle_discount': discount + '%',
          '_bundle_items': this.items.length.toString()
        }
      });
    }

    // Loading state
    this.ctaBtn.textContent = 'ADDING TO CART\u2026';
    this.ctaBtn.classList.add('bundle-sidebar__cta--loading');
    this.ctaBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function () {
      // Clear state
      self.items = [];
      self.clearHighlights();
      self.save();
      self.render();

      // Open cart drawer (theme's built-in event)
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

      // Success feedback
      self.ctaBtn.textContent = '\u2713 ADDED TO CART!';
      setTimeout(function () {
        self.ctaBtn.textContent = 'ADD BUNDLE TO CART';
        self.ctaBtn.classList.remove('bundle-sidebar__cta--loading');
      }, 2500);

      // Close mobile drawer
      if (self.mobileOpen) self.toggleMobile();
    })
    .catch(function (err) {
      console.error('Bundle cart error:', err);
      self.ctaBtn.textContent = 'ERROR \u2014 TRY AGAIN';
      self.ctaBtn.classList.remove('bundle-sidebar__cta--loading');
      self.ctaBtn.disabled = false;
      setTimeout(function () { self.render(); }, 2500);
    });
  };

  BundleBuilder.prototype.clearHighlights = function () {
    for (var i = 0; i < this.cards.length; i++) {
      this.cards[i].classList.remove('bundle-card--added');
    }
  };

  /* =============================================
     Mobile drawer toggle
     ============================================= */
  BundleBuilder.prototype.toggleMobile = function () {
    this.mobileOpen = !this.mobileOpen;

    if (!this.sidebar) return;

    if (this.mobileOpen) {
      // Create overlay
      var overlay = document.createElement('div');
      overlay.className = 'bundle-overlay';
      overlay.id = 'bundle-overlay';
      document.body.appendChild(overlay);
      var self = this;
      overlay.addEventListener('click', function () { self.toggleMobile(); });

      // Show sidebar as drawer
      this.sidebar.classList.add('bundle-sidebar--mobile-open');
      document.body.style.overflow = 'hidden';

      // Trigger transitions
      requestAnimationFrame(function () {
        overlay.classList.add('bundle-overlay--visible');
      });
    } else {
      // Close
      var ov = document.getElementById('bundle-overlay');
      if (ov) {
        ov.classList.remove('bundle-overlay--visible');
        setTimeout(function () { ov.remove(); }, 300);
      }
      this.sidebar.classList.remove('bundle-sidebar--mobile-open');
      document.body.style.overflow = '';
    }
  };

  /* =============================================
     Session storage
     ============================================= */
  BundleBuilder.prototype.save = function () {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.items)); } catch (e) { /* ok */ }
  };

  BundleBuilder.prototype.restore = function () {
    try {
      var d = sessionStorage.getItem(STORAGE_KEY);
      if (!d) return;
      this.items = JSON.parse(d);
      for (var i = 0; i < this.items.length; i++) {
        var card = this.root.querySelector('[data-product-id="' + this.items[i].productId + '"]');
        if (card) card.classList.add('bundle-card--added');
      }
    } catch (e) { /* ok */ }
  };

  /* =============================================
     Helpers
     ============================================= */
  BundleBuilder.prototype.money = function (cents) {
    var amt = (cents / 100).toFixed(2);
    return this.moneyFmt
      .replace('{{amount}}', amt)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amt.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  };

  BundleBuilder.prototype.esc = function (s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  };

  BundleBuilder.prototype.shake = function (el) {
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetHeight;
    el.style.animation = 'bundle-shake 0.5s ease';
  };

  /* =============================================
     Init on DOM ready
     ============================================= */
  function init() {
    var el = document.getElementById('bundle-builder');
    if (el) window.bundleBuilder = new BundleBuilder(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
